import React, {useEffect} from 'react'
import {Spacer} from '../../../Common/Components/Spacer'
import {MembersPageAuthTemplate} from '../Components/MembersPageAuthTemplate'
import {NavigatorForMemberPage} from '../../Navigator/NavigatorForMemberPage'
import {ColumnFlexContainer} from '../Atoms/Containers'
import {MBContentBodyItemTypography} from '../Atoms/Typographies'
import {LinkButton} from '../Atoms/Buttons'
import {Color} from '../Styles'
import {useTranslation} from 'react-i18next'

type MembersRedirectPageProps = {
  navigator: NavigatorForMemberPage
}
export const MembersRedirectPage: React.VFC<MembersRedirectPageProps> = ({navigator}) => {
  const {t} = useTranslation('member')

  useEffect(() => {
    const timeoutId = setTimeout(() => navigator.goToAccountTopPage(), 10 * 1000)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [navigator])

  return (
    <MembersPageAuthTemplate>
      <Spacer mt={'24px'}>
        <ColumnFlexContainer textAlign={'center'} gap={3}>
          <MBContentBodyItemTypography>リダイレクト中です。</MBContentBodyItemTypography>
          <div>
            <MBContentBodyItemTypography>10秒後に自動で画面遷移します。</MBContentBodyItemTypography>
            <MBContentBodyItemTypography>画面遷移しない場合は、以下のURLより移動してください。</MBContentBodyItemTypography>
            <LinkButton
              color={Color.LinkButton}
              onClick={(): void => {
                navigator.goToAccountTopPage()
              }}
            >
              {t('MYアカウント.ページ名')}
            </LinkButton>
          </div>
        </ColumnFlexContainer>
      </Spacer>
    </MembersPageAuthTemplate>
  )
}
